<template>
  <sui-page>
    <sui-page-header :pageId="this.$options.name" />
    <sui-page-contents>
      <div class="comm_scr_wrap">
        <div class="row">
          <div class="col-xs-1">
            <sui-input-label
              :label="$t('MSG_TXT_MDLE')"
              :vertical="false"
            />
          </div>
          <div class="col-xs-3">
            <sui-module-submodule-select
              :pageId="this.$options.name"
              :selectedMd="searchBox.moduleCode"
              :selectedSmd="searchBox.subModuleCode"
              :defaultMdOption="'all'"
              :defaultSmdOption="'all'"
            />
          </div>
          <div class="col-xs-1">
            <sui-input-label
              :label="$t('MSG_TXT_MNTR_PRD')"
              :vertical="false"
            />
          </div>
          <div class="col-xs-3">
            <sui-code-select
              :selected="searchBox.taskMonitoringCycleTypeCode"
              codeId="COD_TASK_MNTR_CYCL_TYPE"
              :defaultOption="'all'"
            />
          </div>
          <div class="col-xs-1">
            <sui-input-label
              :label="$t('MSG_TXT_TASK_MNTR_TYPE_NM')"
              :vertical="false"
            />
          </div>
          <div class="col-xs-3">
            <sui-text-field
              v-model.trim="searchBox.taskMonitoringTypeName"
              default
              value
              :disabled="false"
              :clearable="true"
              :readonly="false"
            />
          </div>
        </div>
        <div class="row">
          <div class="col-xs-1">
            <sui-input-label
              :label="$t('MSG_TXT_RQS_DTM')"
              :vertical="false"
            />
          </div>
          <div class="col-xs-3">
            <sui-range-date-picker
              ref="datePicker"
              v-model="rangeDate"
              :value="rangeDate"
            />
          </div>
          <div class="col-xs-1">
            <sui-input-label
              :label="$t('MSG_TXT_RQS_STT')"
              :vertical="false"
            />
          </div>
          <div class="col-xs-3">
            <sui-code-select
              :selected="searchBox.taskMonitoringRequestStateCode"
              codeId="COD_TASK_MNTR_RQS_STT"
              :defaultOption="'all'"
            />
          </div>
          <div class="col-xs-1">
            <sui-input-label
              :label="$t('MSG_TXT_SEARCH_COND')"
              :vertical="false"
            />
          </div>
          <div class="col-xs-3">
            <sui-code-select
              :selected="searchBox.searchCondition"
              codeId="COD_TASK_MNRT_RQS_SEARCH_COND"
              :defaultOption="'all'"
            />
            <div class="comp_spacing" />
            <sui-text-field
              v-model.trim="searchBox.searchWord"
              placeholder=""
              default
              value
              :disabled="false"
              :clearable="true"
              :readonly="false"
              @keyup.enter="onSearch"
            />
          </div>
        </div>
        <div class="btn_wrap">
          <sui-button
            type="button"
            class="comm_btn_Reset"
            @click="onReset"
          >
            {{ $t("MSG_BTN_RESET") }}
          </sui-button>
          <sui-button
            v-permission:read="this.$options.name"
            type="button"
            class="comm_btn_Scr"
            @click="onSearch"
          >
            {{ $t("MSG_BTN_SEARCH") }}
          </sui-button>
        </div>
      </div>
      <div class="mrB30" />
      <!-- <div class="comm_title_wrap">
        <h4>업무 모니터링 목록</h4>
      </div> -->
      <sui-grid
        ref="grid"
        :columns="gridColumns0"
        :dataset="'dsTaskMonitoringRequest'"
        :initial-pagesize="10"
        :showDisplayCountControl="false"
      />
      <div class="comm_btn_wrap">
        <sui-button
          v-permission:create="this.$options.name"
          type="button"
          class="comm_btn_solid"
          @click="onCreate"
        >
          {{ $t("MSG_BTN_RGST") }}
        </sui-button>
      </div>
    </sui-page-contents>

    <!-- compoenets -->

    <sui-popup
      v-model="isShowPopUpNew"
      :title="$t('MSG_TIT_TASK_MNTR_TYPE_RGST')"
    >
      <p01
        :pageId="this.$options.name"
        @save="save('NEW')"
        @close="popOpenOrClose('NEW')"
      />
    </sui-popup>

    <sui-popup
      v-model="isShowPopUpModify"
      :title="$t('MSG_TIT_TASK_MNTR_TYPE_DTL')"
    >
      <p02
        :pageId="this.$options.name"
        :taskMonitoringRequestUID="taskMonitoringRequestUID"
        @save="save('MODIFY')"
        @close="popOpenOrClose('MODIFY')"
      />
    </sui-popup>
  </sui-page>
</template>
<script>

import p01 from './components/PGE_CMS_00015_P01';
import p02 from './components/PGE_CMS_00015_P02';

export default {
  name: 'PGE_CMS_00015', // eslint-disable-line vue/name-property-casing
  components: {
    p01,
    p02,
  },
  data() {
    return {

      // Search Box
      searchBox: {
        moduleCode: { key: '', label: '' },
        subModuleCode: { key: '', label: '' },
        taskMonitoringCycleTypeCode: { key: '', label: '' },
        taskMonitoringTypeUseYn: { key: '', label: '' },
        taskMonitoringTypeName: '',
        taskMonitoringRequestStateCode: { key: '', label: '' },
        searchCondition: { key: '', label: '' },
        searchWord: '',

        firstRegistrationUserId: '', // 요청자ID

        taskMonitoringParamStartDTM: '',
        taskMonitoringParamEndDTM: '',
      },

      rangeDate: {
        from: '',
        to: '',
      },

      localdata0: [],

      gridColumns0: [{
        text: this.$t('MSG_TXT_MDLE'),
        datafield: 'moduleName',
        width: 100,
      }, {
        text: this.$t('MSG_TXT_SMDLE'),
        datafield: 'subModuleName',
        width: 100,
      }, {
        text: this.$t('MSG_TXT_TASK_MNTR_TYPE_NM'),
        datafield: 'taskMonitoringTypeName',
        createwidget: (row, column, value, htmlElement) => {
          utils.getGridCellFactory().createCellButton(row, column, value, htmlElement, {
            handler: this.onGridButtonClicked,
            type: 'link',
          }, this.dsTaskMonitoringRequest, this.$refs.grid);
        },
        initwidget(row, column, value, htmlElement) {
          utils.getGridCellFactory().refreshCell(row, column, value, htmlElement);
        },

      }, {
        text: this.$t('MSG_TXT_MNTR_PRD'),
        datafield: 'taskMonitoringCycleTypeName',
        width: 100,
      }, {
        text: this.$t('MSG_TXT_RQS_USR'),
        datafield: 'firstRegistrationUserId',
        width: '200px',
        createwidget: (row, column, value, htmlElement) => {
          utils.getGridCellFactory().createCellUserName(row, column, value, htmlElement,
            {
              displayType: '1', // "1", "2" - default: "1"
              type: 'sublink', // 'link', 'sublink' - default: "link"
            }, this.dsTaskMonitoringRequest, this.$refs.grid);
        },
        initwidget(row, column, value, htmlElement) {
          utils.getGridCellFactory().refreshCell(row, column, value, htmlElement);
        },
      }, {
        text: this.$t('MSG_TXT_RQS_START_DT'),
        datafield: 'taskMonitoringStartDate',
        createwidget: (r, c, v, h) => utils.getGridCellFactory().createCellDateLabel(r, c, v, h, { formatOption: 'S' }, this.dsTaskMonitoringRequest, this.$refs.grid),
        initwidget: (r, c, v, h) => utils.getGridCellFactory().refreshCell(r, c, v, h),
        width: 100,
      }, {
        text: this.$t('MSG_TXT_RGST_DTM'),
        datafield: 'firstRegistrationDTM',
        createwidget: (r, c, v, h) => utils.getGridCellFactory().createCellDateLabel(r, c, v, h, this.dsTaskMonitoringRequest, this.$refs.grid),
        initwidget: (r, c, v, h) => utils.getGridCellFactory().refreshCell(r, c, v, h),        
        width: 150,
      }, {
        text: this.$t('MSG_TXT_RQS_STT'),
        datafield: 'taskMonitoringRequestStateName',
        width: 100,
      }],

      // 팝업 관련
      taskMonitoringRequestUID: '',
      isShowPopUpNew: false,
      isShowPopUpModify: false,
    };
  },
  computed: {},
  watch: {},
  datasets: [{
    id: 'dsTaskMonitoringRequest',
    type: 'local',
    data: 'localdata0',
    datafields: [
      { type: 'string', name: 'taskMonitoringHistoryUID', map: 'taskMonitoringHistoryUID' },
      { type: 'string', name: 'taskMonitoringRequestUID', map: 'taskMonitoringRequestUID' },
      { type: 'string', name: 'taskMonitoringTypeUID', map: 'taskMonitoringTypeUID' },
      { type: 'string', name: 'taskMonitoringStartDate', map: 'taskMonitoringStartDate' },
      { type: 'string', name: 'taskMonitoringRequestStandardValue', map: 'taskMonitoringRequestStandardValue' },
      { type: 'string', name: 'taskMonitoringRequsetTemporaryPauseYn', map: 'taskMonitoringRequsetTemporaryPauseYn' },
      { type: 'string', name: 'moduleCode', map: 'moduleCode' },
      { type: 'string', name: 'moduleName', map: 'moduleName' },
      { type: 'string', name: 'subModuleCode', map: 'subModuleCode' },
      { type: 'string', name: 'subModuleName', map: 'subModuleName' },
      { type: 'string', name: 'taskMonitoringCycleTypeCode', map: 'taskMonitoringCycleTypeCode' },
      { type: 'string', name: 'taskMonitoringCycleTypeName', map: 'taskMonitoringCycleTypeName' },
      { type: 'string', name: 'taskMonitoringParamStartDTM', map: 'taskMonitoringParamStartDTM' },
      { type: 'string', name: 'taskMonitoringParamEndDTM', map: 'taskMonitoringParamEndDTM' },
      { type: 'string', name: 'taskMonitoringTypeName', map: 'taskMonitoringTypeName' },
      { type: 'string', name: 'taskMonitoringRequestStateCode', map: 'taskMonitoringRequestStateCode' },
      { type: 'string', name: 'taskMonitoringRequestStateName', map: 'taskMonitoringRequestStateName' },
      { type: 'string', name: 'taskMonitoringResultFilePath', map: 'taskMonitoringResultFilePath' },
      { type: 'string', name: 'firstRegistrationDTM', map: 'firstRegistrationDTM' },
      { type: 'string', name: 'firstRegistrationUserId', map: 'firstRegistrationUserId' },
    ],
  }],
  mounted() {},
  beforeUpdate() {},
  updated() {},
  beforeDestroy() {},
  destroyed() {},
  methods: {
    /** ***************************************************************************
        이벤트 영역
      ***************************************************************************** */
    onReset() {
      this.resetSearchBox();
    },
    onSearch() {
      this.searchTaskMonitoringRequest();
    },
    onCreate() {
      this.taskMonitoringRequestUID = '';
      this.popOpenOrClose('NEW');
    },
    // 그리드 업무 모니터링 유형명 클릭
    onGridButtonClicked(btn, dataRow) {
      this.taskMonitoringRequestUID = dataRow.taskMonitoringRequestUID;
      this.popOpenOrClose('MODIFY');
    },
    /** ***************************************************************************
        함수 영역
      ***************************************************************************** */
    setDatePickerToSearchBox() {
      if (this.rangeDate.from !== null && this.rangeDate.from !== '') {
        const startDTM = utils.dateformatToServer(this.rangeDate.from);
        this.searchBox.taskMonitoringParamStartDTM = `${startDTM.substr(0, 8)}000000`;
      }
      if (this.rangeDate.to !== null && this.rangeDate.to !== '') {
        const endDTM = utils.dateformatToServer(this.rangeDate.to);
        this.searchBox.taskMonitoringParamEndDTM = `${endDTM.substr(0, 8)}235959`;
      }
    },
    resetSearchBox() {
      const has = Object.prototype.hasOwnProperty;
      utils.forEach(this.searchBox, (values, key) => {
        if (has.call(this.searchBox[key], 'key')) {
          this.searchBox[key] = { key: '', label: '' };
        } else {
          this.searchBox[key] = '';
        }
      });

      this.searchBox.moduleCode.key = 'ALL';
      this.searchBox.subModuleCode.key = 'ALL';

      this.searchBox.taskMonitoringCycleTypeCode.key = 'ALL';
      this.searchBox.taskMonitoringRequestStateCode.key = 'ALL';
      this.searchBox.searchCondition.key = 'ALL';

      this.rangeDate = { from: null, to: null };
    },
    searchTaskMonitoringRequest() {
      if (this.onClickValidate()) return false;

      this.setDatePickerToSearchBox();

      // searchBox -> paramsObj변환 { key : value, key : value }
      const queryParams = utils.reduce(this.searchBox, (result, value, key) => {
        const objResult = utils.clone(result);
        if (utils.isUndefined(value) === false && value !== null) {
          objResult[key] = utils.isUndefined(value.key) ? utils.trim(value) : utils.trim(value.key);
        }
        return objResult;
      }, {});


      http.request(this.$options.name, 'DTS_CMS_00037', {
        query: queryParams,
      }).then(res => {
        console.log(res);

        // utils.forEach(res.data, item => {
        //   const objItem = item;
        //   objItem.taskMonitoringTypeName = [
        //     { key: item.taskMonitoringTypeName, label: item.taskMonitoringTypeName, type: 'sublink' },
        //   ];
        // });

        this.dsTaskMonitoringRequest.setRawData(res.data);
      }).catch(error => {
        console.log(error);
      });

      return null;
    },
    save(sSaveFlag) {
      this.popOpenOrClose(sSaveFlag);
      this.searchTaskMonitoringRequest();
    },
    popOpenOrClose(sPopUpFlag) {
      if (sPopUpFlag === 'NEW') {
        this.isShowPopUpNew = !this.isShowPopUpNew;
      } else if (sPopUpFlag === 'MODIFY') {
        this.isShowPopUpModify = !this.isShowPopUpModify;
      }
    },
    /* 달력의 오류를 확인할 수 있는 validate 함수 */
    onClickValidate() {
      // if (this.onClickValidate()) return false;
      if (!this.$refs.datePicker.isValid()) {
        utils.messageBox('warning', this.$t('MSG_ALT_CHK_DT'), null, null);
        return true;
      }
      return false;
    },
  },
};
</script>
<style scoped>
</style>
